import React from 'react';
import 'react-step-progress-bar/styles.css';
import { ProgressBar, Step } from 'react-step-progress-bar';

const MultiStepProgressBar = (props) => {
  let stepPercentage = 0;

  if (props.currentStep === 1) {
    stepPercentage = 50;
  } else if (props.currentStep === 2) {
    stepPercentage = 95;
  } else {
    stepPercentage = 0;
  }

  return (
    <ProgressBar percent={stepPercentage}>
      <Step>
        {({ accomplished, index }) => (
          <div
            className={`indexedStep ${
              accomplished ? 'accomplished' : null
            } sr-only`}
          >
            <span className="sr-only">Step </span>
            {index + 1}
          </div>
        )}
      </Step>
      <Step>
        {({ accomplished, index }) => (
          <div
            className={`indexedStep ${
              accomplished ? 'accomplished' : null
            } sr-only`}
          >
            <span className="sr-only">Step </span>
            {index + 1}
          </div>
        )}
      </Step>
    </ProgressBar>
  );
};

export default MultiStepProgressBar;
